import axios from "axios"

import { apiDomain } from "../../store/constants"

const MonthlyProgress = {
    getPlanForEdit (payload) {
        let route = payload.form_type === 'C' ? 'progress-month' : 'progress-month/form-b'
        return axios({
            url: apiDomain + `api/${route}/${payload.id}`,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    updatePlan (payload) {
        return axios({
            url: apiDomain + `api/progress-month/update/${payload.id}`,
            method: 'POST',
            data: payload.data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getProgressRSP (params) {
        return axios({
            url: apiDomain + `api/progress-month`,
            method: 'GET',
            params

        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    extendProgressMonth (payload) {
        return axios({
            url: apiDomain + `api/progress-month/extendProgressMonth`,
            method: 'POST',
            data: payload
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    updateProgressData (payload) {
        return axios({
            url: apiDomain + `api/progress-month/update-progress`,
            method: 'POST',
            data: payload
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
}

export default MonthlyProgress